import api from "./api";

const parkingYardService = {
  upload: (file, { bankName, branchName } = {}) => {
    const formData = new FormData();
    formData.append("file", file);
    if (bankName) formData.append("bankName", bankName);
    if (branchName) formData.append("branchName", branchName);
    return api.post("/parking-yards/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 300000,
    });
  },

  removeBySource: ({ bankName, branchName } = {}) =>
    api.delete("/parking-yards/by-source", {
      params: { bankName, branchName },
    }),

  search: (params = {}) => api.get("/parking-yards/search", { params }),

  list: (params = {}) => api.get("/parking-yards", { params }),

  listUploadSources: () => api.get("/parking-yards/upload-sources"),

  getById: (id) => api.get(`/parking-yards/${id}`),

  setStatus: (id, isActive) => api.patch(`/parking-yards/${id}/status`, { isActive }),

  remove: (id) => api.delete(`/parking-yards/${id}`),

  downloadSample: () =>
    api.get("/parking-yards/sample", { responseType: "blob" }),
};

export default parkingYardService;
